module.exports = __webpack_public_path__ + "static/media/img004.79936bd1.jpg";